import { render } from "./InputInformation.vue?vue&type=template&id=690913dc&scoped=true"
import script from "./InputInformation.vue?vue&type=script&lang=js"
export * from "./InputInformation.vue?vue&type=script&lang=js"

import "./InputInformation.vue?vue&type=style&index=0&id=690913dc&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690913dc"]])

export default __exports__